import React from "react";
import { Box, Button, Stack, Typography } from "@mui/material";
import { ArrowForward } from "@mui/icons-material";
import { DASH } from "../../dashboard/tokens";

type Props = {
  /** Where on the page this slot sits — for whoever fills it with real ads later. */
  placement: string;
  onAction: () => void;
  actionLabel: string;
};

/**
 * The open ad space at the bottom of Home Status (Asher: insurance, mortgage,
 * whatever — monetizable). Until a partner is signed it carries a house ad,
 * Option A's "Keep Building Your Home History". Swap the contents here; the
 * slot, its size and its "Sponsored"-style label stay put.
 */
const AdSlot: React.FC<Props> = ({ placement, onAction, actionLabel }) => (
  <Box
    component="aside"
    aria-label="Promotion"
    data-ad-slot={placement}
    data-testid="ad-slot"
    sx={{
      position: "relative",
      overflow: "hidden",
      borderRadius: DASH.radius,
      p: { xs: 5, md: 7 },
      bgcolor: DASH.peach,
      border: `1px solid rgba(251,190,104,0.5)`,
    }}
  >
    <Typography sx={{ fontSize: 11, fontWeight: 800, letterSpacing: 1, color: DASH.amber, mb: 1.5 }}>
      FROM SIMPLERHOME
    </Typography>
    <Stack direction={{ xs: "column", md: "row" }} spacing={4} alignItems={{ xs: "flex-start", md: "center" }} justifyContent="space-between">
      <Box sx={{ maxWidth: 560, position: "relative" }}>
        <Typography component="h3" sx={{ fontWeight: 800, fontSize: { xs: 20, md: 22 }, color: DASH.teal }}>
          Keep Building Your Home History
        </Typography>
        <Typography sx={{ mt: 1, color: "#3a4646", fontSize: 15 }}>
          Every repair, upgrade and permit you record makes your home easier to maintain, insure and sell.
        </Typography>
      </Box>
      <Button
        onClick={onAction}
        endIcon={<ArrowForward />}
        sx={{ bgcolor: DASH.teal, color: "#fff", fontWeight: 700, borderRadius: 2, px: 5, whiteSpace: "nowrap", "&:hover": { bgcolor: DASH.tealDark } }}
        data-testid="ad-slot-cta"
      >
        {actionLabel}
      </Button>
    </Stack>
  </Box>
);

export default AdSlot;
